import React, { useState, useEffect} from 'react';

import { Add, Delete} from '@mui/icons-material';
import {Button, Container, Box} from '@mui/material';


import * as Config from '../Config.js'; 

import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";

//import * as Helper from '../Helper.js'; 
import TopAppBar from './TopAppBar' ;
import { useNavigate,  useParams} from 'react-router-dom';

import { useTranslation } from "react-i18next";

function EventScreen() {
    const {t} = useTranslation() ;
    const [pictures, setPictures] = useState([]) ;  
    const navigate = useNavigate();
    const {id_event, type} = useParams() ;
    const [id_user, setId_user] = useState() ;  
    const [event, setEvent] = useState(null) ;  
    
     
    useEffect(() => { 
        console.log('useeffect invoked') ;
        
        const data = new FormData();
        data.append('id_event', id_event);

        fetch(Config.apiUrl  + '/site/pictures',  {
            method: 'POST',
            credentials: 'include',
            body: data,
        })
        .then(response => response.json())
        .then( (res) => {
            if (res.success) {
                console.log('listPictures') ;
                console.log(res.data) ;
                setPictures(res.data) ;
                setId_user(res.id_user) ;
                setEvent(res.event) ; 
            } else {
                console.log(res.error) ;
            }
        })
        .catch((e) => navigate('/'))
    // the next line prevents the useEffect excessive warning
    // eslint-disable-next-line react-hooks/exhaustive-deps        
    }, []) ; 
    

    const isOwner = () => {
        console.log('isOwner') ;
        if (event) {
            return (parseInt(id_user) === parseInt(event.id_user)) ; 
        } else {
            return false ;
        }
    }
    
    const isEmpty = () => {
        return (pictures.length === 0) ;
    }
    
    
    const actionDeleteEvent = () => {
        if (window.confirm("This event and associated pictures will be deleted")) {
              deleteEvent() ;
        }      
    }  
        
    
    const deleteEvent = () => { 
        const data = new FormData();
        data.append('id_event', id_event);

        fetch(Config.apiUrl  + '/site/delete-event',  {
            method: 'POST',
            credentials: 'include',
            body: data,
        })
        .then(response => response.json())
        .then( (res) => {
            if (res.success) {
               navigate('/my_events/' + type )
            } else {
                alert(res.error) ;
            }
        })
    }
    
 
    return (
        <Container maxWidth="sm" >
            <TopAppBar 
            title={event ? event.name : ''} 
            returnLink={"/my_events/" + type}
            />
            {isOwner() &&
            <Box
                display="flex"
                justifyContent="space-around"
                alignItems= "center"
                marginTop="5%"
                marginBottom="5%"
            >    
                <Button 
                    variant="outlined" 
                    startIcon={<Add />} 
                    onClick={ () => { navigate('/picture/' + (event ? event.id : '0') + '/' + type)}}>
                    {t("Add Picture")}
                </Button>
                <Button 
                    sx={{color: 'error.main'}} 
                    variant="outlined" 
                    startIcon={<Delete />} 
                    onClick={ () => actionDeleteEvent()}>
                    {t("Delete this event")}
                </Button>
            </Box>    
            } 
            {!isEmpty() &&
            <ImageGallery 
                items={pictures.map( (item, i) => {
                    return {original: Config.imageDir + item.url,
                            thumbnail: Config.imageDir +  item.url

                        } ;
                })}
                thumbnailHeight = "50px"
                thumbnailWidth = "50px"
            />
            }
        </Container>
    );

}
export default EventScreen ;